var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 208,
    viewBox: "0 0 190 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.097 84.3237C117.097 85.0686 113.87 85.6724 109.889 85.6724L16.1791 84.7415C6.88242 84.7415 6.88242 83.906 16.1791 83.906L109.889 82.9751C113.87 82.9751 117.097 83.5789 117.097 84.3237Z",
    fill: "url(#paint0_linear_4560_3607)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.8213 205.701C92.8213 206.446 90.8849 207.049 88.4962 207.049L32.2704 206.118C26.6924 206.118 26.6924 205.283 32.2704 205.283L88.4962 204.352C90.8849 204.352 92.8213 204.956 92.8213 205.701Z",
    fill: "url(#paint1_linear_4560_3607)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M53.9803 4L3.99965 4",
    stroke: "url(#paint2_linear_4560_3607)",
    strokeWidth: 7.81519,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M186 32.8054L144.349 32.8054",
    stroke: "url(#paint3_linear_4560_3607)",
    strokeWidth: 7.81519,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4560_3607",
    x1: 109.889,
    y1: 84.7892,
    x2: 16.1791,
    y2: 84.7892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4560_3607",
    x1: 88.4962,
    y1: 206.166,
    x2: 32.2704,
    y2: 206.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4890DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4890DF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4560_3607",
    x1: 53.9803,
    y1: 4.5,
    x2: 3.99965,
    y2: 4.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D74E55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D74E55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4560_3607",
    x1: 186,
    y1: 33.3054,
    x2: 144.349,
    y2: 33.3054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D74E55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D74E55",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.512f22f5f070a05bcdda2a39a1cd3917.svg";
export { ForwardRef as ReactComponent };